<template>
  <a-card :bordered="false">
    <div v-if="!course.id">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :md="6" :sm="12">
              <a-form-item label="课程名称">
                <a-input
                  placeholder="请输入课程名称"
                  v-model="queryParam.name"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8">
              <a-form-item label="课程类型">
                <a-select
                  v-model="queryParam.level"
                  placeholder="请选择课程类型"
                >
                  <a-select-option :value="null">请选择</a-select-option>
                  <a-select-option :value="1">初级课程</a-select-option>
                  <a-select-option :value="2">中级课程</a-select-option>
                  <a-select-option :value="3">高级课程</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="8">
              <span
                style="float: left; overflow: hidden"
                class="table-page-search-submitButtons"
              >
                <a-button type="primary" @click="searchQuery" icon="search"
                  >查询</a-button
                >
                <a-button
                  type="primary"
                  @click="searchReset"
                  icon="reload"
                  style="margin-left: 8px"
                  >重置</a-button
                >
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- table区域-begin -->
      <a-table
        ref="table"
        bordered
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange"
      >
        <span slot="courseNum" slot-scope="text, record">
          <a @click="showModal(record)">
            {{ record.groupCount }}
          </a>
        </span>
        <span slot="courseDetail" slot-scope="text, record, index">
          <a @click="lookDetail(record, index)">查看</a>
        </span>
        <!-- <span slot="courseData" slot-scope="text, record">
          <a @click="lookDetail(record)">查看</a>
        </span> -->
      </a-table>
      <!-- table区域-end -->
    </div>
    <div v-else>
      <div
        @click="course = {}"
        style="position: absolute; right: 6px; top: 10px;"
      >
        <a-icon type="close" :style="{ fontSize: '20px' }" />
      </div>
      <a-row type="flex" justify="space-between" style="margin-bottom:20px;">
        <a-col>
          <h3>{{ course.name }}</h3>
        </a-col>
        <a-col>
          <a-button
            :style="{ marginRight: '20px' }"
            @click="handleAdd(dataSource[activeIndex])"
            >课程安排</a-button
          >
        </a-col>
      </a-row>
      <a-table :columns="columns1" :data-source="data">
        <template slot="name" slot-scope="text">
          <a>{{ text }}</a>
        </template>
        <span slot="courseTime" slot-scope="text, record">
          <span v-if="!changedTime.amCourseTime">
            {{
              record.time_point == 1
                ? course.am_course_time
                : record.time_point == 2
                ? course.noon_course_time
                : course.pm_course_time
            }}
          </span>
          <span v-else>
            {{
              record.time_point == 1
                ? changedTime.amCourseTime
                : record.time_point == 2
                ? changedTime.noonCourseTime
                : changedTime.pmCourseTime
            }}
          </span>
        </span>
      </a-table>
    </div>
    <div>
      <a-modal
        title="开课群"
        :visible="visible"
        @cancel="handleCancel"
        cancelText="关闭"
        :footer="null"
      >
        <a-table :columns="columns2" :data-source="data2">
          <template slot="name" slot-scope="text">
            <a>{{ text }}</a>
          </template>
        </a-table>
      </a-modal>
    </div>
    <!-- 课程安排弹窗组件 -->
    <course-detail-modal
      ref="modalForm"
      @ok="modalFormOk"
    ></course-detail-modal>
  </a-card>
</template>

<script>
import Bus from './modlues/bus';
import courseDetailModal from './courseDetailModal';
import { courseList, courseGroupList } from '@/api/api';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
// 课程包详情表格数据
const columns1 = [
  {
    title: '主题',
    align: 'center',
    dataIndex: 'theme'
  },
  {
    title: '时间',
    align: 'center',
    dataIndex: 'classTime',
    scopedSlots: {
      customRender: 'courseTime'
    }
  },
  {
    title: '课程内容',
    align: 'center',
    dataIndex: 'name',
    ellipsis: true
  },
  {
    title: '预计时长(分钟)',
    align: 'center',
    dataIndex: 'last'
  },
  {
    title: '总结页',
    align: 'center',
    dataIndex: 'summary_text',
    ellipsis: true
  },
  {
    title: '讲义',
    align: 'center',
    dataIndex: 'materialCount'
  },
  {
    title: '作业',
    align: 'center',
    dataIndex: 'workCount'
  }
];
// 开课群表格数据
const columns2 = [
  {
    title: '群聊',
    align: 'center',
    dataIndex: 'name'
  },
  {
    title: '群成员数',
    align: 'center',
    dataIndex: 'menberNum'
  },
  {
    title: '班主任',
    align: 'center',
    dataIndex: 'teacherName'
  },
  {
    title: '当前进度',
    align: 'center',
    dataIndex: 'status',
    customRender: function(text, record, index) {
      if (text === '0') {
        return '未开始';
      } else if (text == '1') {
        return '进行中';
      } else if (text == '2') {
        return '已结束';
      }
    }
  }
];
export default {
  name: 'CourseCenter',
  mixins: [JeecgListMixin],
  components: {
    courseDetailModal // 课程安排弹窗组件
  },
  data() {
    return {
      columns: [
        {
          title: '课程名称',
          align: 'center',
          dataIndex: 'name',
          width: 200
        },
        {
          title: '课程类型',
          align: 'center',
          width: 100,
          dataIndex: 'level',
          customRender: function(text, record, index) {
            if (text === 1) {
              return '初级课程';
            } else if (text == 2) {
              return '中级课程';
            } else {
              return '高级课程';
            }
          }
        },
        {
          title: '课程安排',
          align: 'center',
          width: 120,
          dataIndex: 'dayCount',
          customRender: function(text, record, index) {
            return text + '天';
          }
        },
        {
          title: '添加时间',
          align: 'center',
          dataIndex: 'createTime',
          width: 130
        },

        {
          title: '已开课群',
          align: 'center',
          dataIndex: 'groupCount',
          width: 80,
          scopedSlots: {
            customRender: 'courseNum'
          }
        },
        {
          title: '课程详情',
          align: 'center',
          width: 100,
          scopedSlots: {
            customRender: 'courseDetail'
          }
        }
        // {
        //   title: '课程数据',
        //   align: 'center',
        //   width: 100,
        //   scopedSlots: {
        //     customRender: 'courseData'
        //   },
        // }
      ], // 课程包列表数据
      url: {
        list: process.env.VUE_APP_CMS_COURSE + '/course/findCoursePack'
      },
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      course: {
        // id: '12'
      },
      data: [],
      data2: [],
      columns1,
      columns2,
      visible: false,
      changedTime: {},
      activeIndex: ''
    };
  },
  computed: {},
  // inject: ['reload'],
  methods: {
    // 查看课程详情
    lookDetail(record, index) {
      this.course = record;
      this.activeIndex = index;
      let id = this.course.id;
      courseList({
        coursePackId: id
      }).then(res => {
        if (res.success) {
          this.data = res.result.records;
        }
      });
    },
    // 开课群弹窗
    showModal(record) {
      this.visible = true;
      let id = record.id;
      courseGroupList({
        id
      }).then(res => {
        if (res.success) {
          this.data2 = res.result;
        } else {
        }
      });
    },
    handleCancel(e) {
      this.visible = false;
    }
  },
  mounted() {
    Bus.$on('getTime', e => {
      this.loadData();
      this.changedTime = e;
    });
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';

.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
